import $http from 'middleware/http';
import { htmlGetter, linkParser, parseDateString, getRoundedHref } from './util';



const FILE_NAME = 'navigation.html';


export default {
  namespaced: true,

  state: {
    loaded: false,
    categories: [],
    submenus: [],
  },

  getters: {
    filepath: (state, getters, rootState, rootGetters) => rootGetters['path/$join']('conf', FILE_NAME),
    matchedCategory: (state, getters) => {
      return getters['categories'].find(c => c.matched) || null;
    },
    matchedGroup: (state, getters) => {
      const category = getters['matchedCategory'];
      if (!category) return null;
      return category.groups.find(g => g.matched) || null;
    },
    matchedLink: (state, getters) => {
      const group = getters['matchedGroup'];
      if (!group) return null;
      return group.links.find(l => l.matched) || null;
    },
    categories: (state, getters, rootState, rootGetters) => {
      const userIsReady = rootGetters['segments/user/ready'];
      const userTypeId = rootGetters['segments/user/id'];

      const currentLocation = getRoundedHref(location.href);

      let currentLink, currentLinkScore = 0;

      const linkFilter = (_link, group) => {
        const { userAttribute } = _link.data;
        const isHidden = userAttribute !== undefined && (!userIsReady || userTypeId !== String(userAttribute));

        const tags = [..._link.tags];
        !!userAttribute && tags.push({ text: '高２年向け', color: 'accent' });

        const link = Object.assign({}, _link, {
          href: rootGetters['path/$resolve'](_link.href),
          group,
          matched: false,
          current: false,
          isHidden,
          tags,
        });

        const linkLocation = getRoundedHref(link.href);
        const myHitScore = linkLocation.split('/').length;
        link.current = currentLocation === linkLocation;
        const isMatch = link.current || currentLocation.indexOf(linkLocation) === 0;

        if (isMatch && myHitScore >= currentLinkScore) {
          currentLink = link;
          currentLinkScore = myHitScore;
        }
        if (dn.$store.getters['config/isManabi']) {
          // サイドメニュー：判定の確認画面でマーク模試取得画面が開かれていることになる対策
          if (currentLocation.match(/hantei/)) {
            currentLink = false;
          }
        }

        if (link.data.created && !link.data.updated) {
          link.data.updated = link.data.created;
        } else if (!link.data.created && link.data.updated) {
          link.data.created = link.data.updated;
        }

        if (link.data.created) {
          link.created = parseDateString(link.data.created);
          link.updated = parseDateString(link.data.updated);
          link.publishState = link.created.timestamp === link.updated.timestamp ? 'created' : 'updated';
        }

        return link;
      };

      const categories = state.categories.map(_category => {
        const category = Object.assign({ matched: false }, _category);
        const groups = category.groups.map(_group => {
          const group = Object.assign({}, _group, {
            category,
            matched: false,
          });
          let hasPublishState = false;
          let latestCreatedLink = null;
          let latestUpdatedLink = null;
          group.links = _group.links.map(_link => {
            const link = linkFilter(_link, group);
            if (link.publishState && !link.isHidden) {
              hasPublishState = true;
              if (!latestCreatedLink || link.created.timestamp > latestCreatedLink.created.timestamp) {
                latestCreatedLink = link;
              }
              if (!latestUpdatedLink || link.updated.timestamp > latestUpdatedLink.updated.timestamp) {
                latestUpdatedLink = link;
              }
            }
            return link;
          }).filter(link => !link.isHidden);

          if (hasPublishState) {
            group.links.forEach(link => {
              if (link.publishState) {
                link.created.latest = link === latestCreatedLink || link.created.timestamp === latestCreatedLink.created.timestamp;
                link.updated.latest = link === latestUpdatedLink || link.updated.timestamp === latestCreatedLink.updated.timestamp;
              }
            });
          }
          return group;
        });
        category.groups = groups;
        return category;
      });

      if (currentLink) {
        currentLink.matched = true;
        currentLink.group.matched = true;
        currentLink.group.category.matched = true;
      }
      return categories;
    },
    category: (state, getters) => id => {
      return getters['categories'].find(category => category.id === id);
    },
    categoryGroup: (state, getters) => (categoryId, groupId) => {
      const category = getters['category'](categoryId);
      if (category) {
        return category.groups.find(group => group.id === groupId);
      }
    },
    submenus: (state, getters, rootState, rootGetters) => {
      return state.submenus.map(menu => Object.assign({}, menu, {href: rootGetters['path/$resolve'](menu.href)}))
    },
    gnaviCategories: (state, getters) => getters.categories.filter(category => (!category.data.gnaviIgnore && category.data.gnaviIgnore !== '')),
    localNaviCategory: (state, getters) => {
      return getters.categories.find(category => (category.matched))
    },
  },

  actions: {
    async load({ commit, getters }) {
      const res = await $http.get(getters['filepath']);
      commit('setData', res.data);
    },
  },

  mutations: {
    setData(state, html) {
      const categories = [], submenus = [];
      const $data = $(`<div>${html}</div>`);

      const $categories = $data.find('dn-categories').children('dn-category');
      $categories.each(function() {
        const $category = $(this);
        const disabled = $category.attr('disabled');
        const isDefault = $category.attr('default');
        const category = {
          id         : $category.attr('id'),
          data       : $category.data(),
          label      : dn.$store.getters['path/$resolve'](htmlGetter($category.children('dn-label'))),
          disabled   : disabled !== undefined && disabled !== 'false',
          default    : isDefault !== undefined && isDefault !== 'false',
          groups     : [],
        };

        const defaultLinks = [];
        const $links = $category.children('dn-link');
        $links.each(function() {
          defaultLinks.push(linkParser($(this), 'default'));
        });
        category.groups.push({
          id: 'default',
          label: null,
          links: defaultLinks,
        });

        const $groups = $category.children('dn-link-group');
        $groups.each(function() {
          const $group = $(this);
          const $label = $group.children('dn-label');
          const group = {
            id: $group.attr('id'),
            label: $label.get(0) ? htmlGetter($label) : null,
            links: [],
          };
          const $links = $group.children('dn-link');
          $links.each(function() {
            group.links.push(linkParser($(this), 'default'));
          });
          category.groups.push(group);
        });

        categories.push(category);
      });

      const $submenus = $data.find('dn-submenus').children('dn-link');
      $submenus.each(function() {
        submenus.push(linkParser($(this)));
      });

      state.categories = categories;
      state.submenus = submenus;
      state.loaded = true;
    },
  },
}



// WEBPACK FOOTER //
// ./src/js/store/modules/navigation.js